module.exports = __webpack_public_path__ + "img/bancontact.1891f0c5.svg";